import { stringify } from 'qs';
import {request} from "../../utils/apiUtils";
import {URL_API} from "../../url.config";

let AdminContract = {
    getDataList: (payload, callback) => {
        return request({
            url: `${URL_API}/api/one-book-core/secure/document/admin-get-list-document-by-contract?${stringify(payload)}`,
            method: 'GET',
        }, callback);
    },
    getReportContract: (payload, callback) => {
        return request({
            url: `${URL_API}/api/one-book-core/admin/report-contract/search?${stringify(payload)}`,
            method: 'GET'
        }, callback)
    },
    getContractLog: (payload, callback) => {
        return request({
            url: `${URL_API}/api/one-book-core/secure/contract-log/search-by-contract-id?${stringify(payload)}`,
            method: 'GET'
        }, callback)
    },
}
export default AdminContract
